// extracted by mini-css-extract-plugin
export var animationContainer = "_fg-0";
export var asteriskIcon = "_fg-8";
export var conversationLeftSection = "_fg-4";
export var conversationListItem = "_fg-3";
export var conversationMiddleSection = "_fg-5";
export var conversationRightSection = "_fg-6";
export var detailsContent = "_fg-1";
export var listContainer = "_fg-7";
export var modalContent = "_fg-2";